import React from "react";
import "./MobileMenu.css";
import "./Home.css";


const MobileMenu = ({ open, onClose }) => {
  return (
    <>
      {/* OFFCANVAS */}
      <div className={`vl-offcanvas ${open ? "active" : ""}`}>
        <div className="vl-offcanvas-wrapper">

          {/* HEADER */}
          <div className="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
            <div className="vl-offcanvas-logo">
              <img src="/assets/img/logo/logo1.png" alt="logo" />
            </div>

            <button
              className="vl-offcanvas-close-toggle"
              onClick={onClose}
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </div>

          {/* MENU (future use) */}
          <div className="vl-offcanvas-menu d-lg-none mb-40">
            <ul>
              <li onClick={onClose}>Home</li>
              <li onClick={onClose}>About Us</li>
              <li onClick={onClose}>Services</li>
              <li onClick={onClose}>Contact</li>
            </ul>
          </div>

          {/* CONTACT */}
         {/*  <div className="vl-offcanvas-info">
            <h3>Contact Us</h3>
            <span><i className="fa-regular fa-envelope"></i> +57 9954 6476</span>
            <span><i className="fa-solid fa-phone"></i> hello@exdos.com</span>
            <span><i className="fa-solid fa-location-dot"></i> Bhemeara, Kushtia</span>
          </div> */}

        </div>
      </div>

      {/* OVERLAY */}
      {open && <div className="vl-offcanvas-overlay" onClick={onClose}></div>}
    </>
  );
};

export default MobileMenu;
